export default __webpack_public_path__ + "f1ba014a183347f4317fc53bf7e53de3.png";